import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/driver/dispatch/page`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 调度资源--分配调度组
export function fenDept(data) {
  return request.send({
    url: `/pmy/sys/driver/dispatch/dept`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 调度资源--分配调度人员
export function fenDispatcher(data) {
  return request.send({
    url: `/pmy/sys/driver/dispatch/dispatcher`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 调度资源--批量分配调度
export function batchDispatcher(data) {
  return request.send({
    url: `/pmy/sys/driver/dispatch/batch`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 调度资源--统计总览
export function getDispatchOverview(deptId) {
  return request.send({
    url: `/pmy/sys/driver/dispatch/overview?deptId=${deptId ? deptId : ""}`,
    method: "get",
  });
}
